import * as yup from 'yup';

import { REQUIRED } from '../forms/errorsText.js';
import BonusPresenter from '../presenters/Membership/BonusPresenter';

export const validationFields = {
  bonusType: yup.string().required(REQUIRED),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (bonus) => {
  return {
    bonusType: BonusPresenter.bonusType(bonus) || '',
  };
};
